<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomLoader from "@/components/widgets/custom-loader";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    CustomLoader,
    PageHeader,
  },
  data() {
    return {
      title: "Store Logs Reports",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Logs Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "item",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "quantity",
          label: "Quantity",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "by",
          label: "Brought By",
          sortable: true,
        },
        {
          key: "Added By",
          label: "Added By",
          sortable: true,
        },
        {
          key: "Added On",
          label: "Added On",
          sortable: true,
        },
      ],
      data: {
        item: 0,
        status: "",
        from: new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "-"),
        to: new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "-"),
      },
    };
  },
  computed: {
    ...mapGetters("inventory", ["StoreLogs", "StoreItems", "SaveStatus"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.StoreLogs ? this.StoreLogs.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StoreLogs ? this.StoreLogs.length : 1;
  },
  methods: {
    ...mapActions({
      FetchLogs: "inventory/fetchStoreLogs",
      FetchStoreItems: "inventory/fetchStoreItems",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.StoreLogs ? this.StoreLogs.length : 1;
      this.currentPage = 1;
    },
    fetch_logs() {
      this.FetchLogs(this.data);
    },
  },
  created() {
    this.FetchStoreItems();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Item</label>
                <select class="form-control" v-model="data.item">
                  <option value="0" selected>All Items</option>
                  <option
                    v-for="(t, index) in StoreItems"
                    :key="index"
                    :value="t.id"
                  >
                    {{ t.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label>Status</label>
                <select class="form-control" v-model="data.status">
                  <option value="" selected>All Statuses</option>
                  <option value="0" selected>Opening Stock</option>
                  <option value="1" selected>Purchases</option>
                  <option value="2" selected>Issued Stock</option>
                  <option value="4" selected>Returns</option>
                  <option value="3" selected>Losses</option>
                </select>
              </div>
              <div class="col-md-2">
                <label>From <span class="required">*</span></label>
                <input type="date" class="form-control" v-model="data.from" />
              </div>
              <div class="col-md-2">
                <label> To <span class="required">*</span></label>
                <input type="date" class="form-control" v-model="data.to" />
              </div>
              <div class="col-md-3 mt-2">
                <br />
                <div class="row">
                  <div class="col-md-8">
                    <button class="btn btn-primary" @click="fetch_logs()">
                      <i class="fa fa-search"></i> Search
                      <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Spinning"
                      ></b-spinner>
                    </button>
                  </div>
                  <div class="col-md-4">
                    <export-excel :data="StoreLogs" name="Store Stock Logs.xls">
                      <b-btn variant="success" class="btn-sm">
                        <i class="fa fa-download"></i>
                        Excel
                      </b-btn>
                    </export-excel>
                  </div>
                </div>
              </div>
            </div>
            <CustomLoader v-if="SaveStatus"></CustomLoader>
            <div v-else>
              <div class="row mt-2">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  :items="StoreLogs ? StoreLogs : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
